import { getCookie, hasCookie, setCookie } from 'cookies-next';
import { useEffect, useRef, useState } from 'react';

import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { useRouter } from 'next/router';

import { useTranslation } from 'next-i18next';

const GdprProvider = ({ children }) => {
  const { pathname } = useRouter();
  const descriptionElementRef = useRef(null);
  const [showGdprDialog, setShowGdprDialog] = useState(
    pathname !== '/cookie-policy' && !hasCookie('localConsent'),
  );
  const [consent, setConsent] = useState(true);

  const onCloseGdprDialog = () => {
    setConsent(true);
    setCookie('localConsent', 'true', {
      maxAge: 60 * 60 * 24 * 365,
    });
    setShowGdprDialog(false);
  };

  // i18s
  const { t } = useTranslation('common');

  useEffect(() => {
    const checkCookiePresence = hasCookie('localConsent');
    if (checkCookiePresence)
      setConsent(getCookie('localConsent') === 'true');
    if (!checkCookiePresence && pathname !== '/cookie-policy')
      setShowGdprDialog(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCookie('localConsent'), pathname]);

  const acceptCookie = () => {
    setConsent(true);
    setCookie('localConsent', 'true', {
      maxAge: 60 * 60 * 24 * 365,
    });
    setShowGdprDialog(false);
    gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
    });
  };

  const denyCookie = () => {
    setConsent(true);
    setShowGdprDialog(false);
    setCookie('localConsent', 'false', {
      maxAge: 60 * 60 * 24 * 365,
    });
    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
    });
    console.info('denying cookie');
  };

  return (
    <div>
      {children}
      <Dialog
        open={showGdprDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="croll-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          align="center"
          className="body text-primary-950"
          sx={{ fontFamily: 'inherit' }}
        >
          {t('dialogs.cookies.title')}
        </DialogTitle>
        <DialogContent dividers={true}>
          <div
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <DialogContentText className="space-y-6">
              <span className="text-primary-950">
                {t('dialogs.cookies.text')}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.iubenda.com/privacy-policy/18635860/cookie-policy"
                  className="ml-1 text-red"
                >
                  Cookie Policy
                </a>
                .
              </span>
            </DialogContentText>
          </div>
        </DialogContent>
        <DialogActions className="justify-center md:justify-end">
          <Button
            onClick={denyCookie}
            size="large"
            color="primary"
            variant="outlined"
          >
            {t('dialogs.cookies.actions.decline')}
          </Button>
          <Button
            color="primary"
            onClick={acceptCookie}
            autoFocus
            variant="contained"
            size="large"
            className="bg-primary hover:bg-primary-600 text-white"
          >
            {t('dialogs.cookies.actions.accept')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GdprProvider;
